'use client';

import { useTranslation } from 'react-i18next';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import AboutResources from '@/components/apps/pages/about/resources/AboutResources';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

export default function ResourcesPageClient() {
  const { t } = useTranslation('common');
  const title = t('자료실');

  return (
    <>
      <VisuallyHiddenPageTitle>{title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout
        desktopPadding={{ top: '0', bottom: '200px' }}
        mobilePadding={{ top: '0', bottom: '100px' }}
      >
        <AboutResources />
      </ResponsiveLayout>
    </>
  );
}
